import React from 'react'
import PersonProfile from 'views/Accounts/PersonDetails/PersonProfile'
export default function ProfileTab({ personData, refetchPerson}) {
  return (
    <>
      <PersonProfile data={personData} refetchPerson={refetchPerson}/>
    </>
  )
}
